module.exports = __webpack_public_path__ + "static/media/question.f29c9539.svg";